import {nextTick, onBeforeMount} from "vue";
import {StorageUtils} from 'xmgoing-utils';
import apps from "@/migo/apps";
import {useRouter} from "vue-router";
import {PageEnum} from "@/enums/pageEnum";
import { isStandalonePath } from '@/router/standaloneRoute';

// 判断当前请求地址 是否为子应用地址
export function hasSubApp (apps: any, href: any) {
  const hrefAry = href.split('/')
  const subName = hrefAry[3];
  if (subName != null && subName.length > 0) {
    const filterAry = apps.filter((itemObj: any) => {
      return itemObj.activeRule === '/' + subName
    })
    if (filterAry.length > 0) {
      return true
    }
  }
  return false
}

/** 刷新还原：必须用字符串 path，对象形式 path 含 ?query 时 Vue Router 会丢掉 query */
function pushHref(router: ReturnType<typeof useRouter>, curHref: string) {
  router.push(curHref);
}

export function usePageFlush(showRouterFlag?:boolean,changeLayout?:Function,selectedKeys?:any){
  const router = useRouter();
  /**
   * 跳转到子应用
   * @param curHref
   */
  const jumpToSubApp=function (curHref){
    //获取真正的跳转路径
    curHref=curHref.replace(location.origin,"");
    window.appObj.resourceUrl=curHref;
    //如果是app展示应用模式
    if(showRouterFlag){
      if(curHref!==PageEnum.BASE_HOME_URL){
        //构造一个应用对象
        const item=JSON.parse(StorageUtils.getSessionItem('curAppItem')+"");
        changeLayout&&changeLayout({item},()=>{
          // nextTick(()=>{
          //   unref(selectedKeys).push(curHref);
          // })
          pushHref(router, curHref);
        });
      }
    }else{
      setTimeout(()=>{
        if(unref(selectedKeys)){
          // 叶子选中按菜单入口 id；无入口时回退 path（收藏等非侧栏入口）
          const entryId = StorageUtils.getSessionItem('curMenuEntryId');
          unref(selectedKeys).value=[entryId || curHref];
        }
      },500)
      pushHref(router, curHref);
    }
  }

  /**
   * 主应用界面
   */
  const jumpToMainAppPage=function (curHref){
    //获取真正的跳转路径
    curHref=curHref.replace(location.origin,"");
    const pathOnly = curHref.split('?')[0];
    if (isStandalonePath(pathOnly)) {
      window.location.replace(curHref);
      return;
    }
    window.appObj.resourceUrl=curHref;
    if(curHref==='/dashboard/appMainPage'){
      router.push(PageEnum.BASE_HOME_URL);
      nextTick(()=>{
        const item=JSON.parse(StorageUtils.getSessionItem('curAppItem')+"");
        changeLayout&&changeLayout({item});
      })
    }else{
      pushHref(router, curHref);
    }
  }

  onBeforeMount(()=>{
    let curHref:string=window.localStorage.getItem("curHref")+"";
    if(curHref==null||curHref==="null"){
      return;
    }
    //判断是否为子应用
    if (StorageUtils.getItem("curHref") !== "" && hasSubApp(apps, StorageUtils.getItem("curHref"))) {
      StorageUtils.removeItem("curHref");
      jumpToSubApp(curHref);
    }else{
      StorageUtils.removeItem("curHref");
      jumpToMainAppPage(curHref);
    }
  })
  return {}
}
